// src/pages/CreatePool.jsx
import React, { useContext } from 'react';
import { ContractContext } from '../contexts/ContractContext';
import PoolCreationForm from '../components/PoolCreationForm';

const CreatePool = () => {
  const { loadActivePools, loadCreatorPools } = useContext(ContractContext);
  
  const handleSuccess = () => {
    // Refresh pool data after successful creation
    loadActivePools();
    loadCreatorPools();
  };
  
  return (
    <div>
      <PoolCreationForm onSuccess={handleSuccess} />
    </div>
  );
};

export default CreatePool;